import axios from 'axios';

import router from '@/router';
import auth from '@/utils/auth';

import {
  DELETE_BUDGET,
  DELETE_BUDGET_ERROR,
  DELETE_BUDGET_SUCCESS,

  GET_BUDGET,
  GET_BUDGET_ERROR,
  GET_BUDGET_SUCCESS,

  // GET_BUDGETS,
  // GET_BUDGETS_ERROR,
  // GET_BUDGETS_SUCCESS,

  SAVE_BUDGET,
  SAVE_BUDGET_ERROR,
  SAVE_BUDGET_SUCCESS,

  DOWNLOAD_BUDGET,
  DOWNLOAD_BUDGET_ERROR,
  DOWNLOAD_BUDGET_SUCCESS,

} from './constants';

export default {
  async [DELETE_BUDGET]({ commit }, budgetID) {
    try {
      commit(DELETE_BUDGET);
      await axios({
        url: `${process.env.API_URL}/api/budgets/${budgetID}`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
      });
      commit(DELETE_BUDGET_SUCCESS);
      router.push({ name: 'Settings Budgets' });
    } catch (err) {
      commit(DELETE_BUDGET_ERROR, err);
    }
  },

  async [GET_BUDGET]({ commit }, { syndicateID, financialYear }) {
    try {
      commit(GET_BUDGET);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${syndicateID}/budgets/${financialYear}/report`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_BUDGET_SUCCESS, response.data);
    } catch (err) {
      commit(GET_BUDGET_ERROR, err);
    }
  },

  async [SAVE_BUDGET]({ commit, dispatch }, data) {
    try {
      commit(SAVE_BUDGET);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${data.syndicateID}/budgets/${data.financialYear}`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data: data.budget,
      });
      dispatch(GET_BUDGET, { syndicateID: data.syndicateID, financialYear: data.financialYear });
      commit(SAVE_BUDGET_SUCCESS, response.data);
    } catch (err) {
      commit(SAVE_BUDGET_ERROR, err);
    }
  },

  async [DOWNLOAD_BUDGET]({ commit }, data) {
    try {
      commit(DOWNLOAD_BUDGET);
      const response = await axios({
        url: `${process.env.API_URL}/api/budgets/download`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(DOWNLOAD_BUDGET_SUCCESS, response.data);
    } catch (err) {
      commit(DOWNLOAD_BUDGET_ERROR, err);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Budget/actions.js